import { getDiscoverFeed, getDiscoverFeedById, getSolutionListing } from "@requests/discoveries";
import { useQuery } from "@tanstack/react-query";
import { toastErrorHandler } from "@utils/requests";
import { FIVE_MINUTES, TEN_MINUTES } from "src/constants/timeConstants";

export const DISCOVER_FEED_QUERY_KEY = "discoverFeed";
export const SOLUTION_LISTING_QUERY_KEY = "solutionListing";

export const useDiscoverFeed = () => {
  return useQuery({
    queryKey: [DISCOVER_FEED_QUERY_KEY],
    queryFn: getDiscoverFeed,
    staleTime: FIVE_MINUTES,
    onError: toastErrorHandler,
  });
};

export const useDiscoverFeedById = (id: number) => {
  return useQuery({
    queryKey: [DISCOVER_FEED_QUERY_KEY, id],
    queryFn: () => getDiscoverFeedById(id),
    enabled: Boolean(id),
    staleTime: FIVE_MINUTES,
    onError: toastErrorHandler,
  });
};

export const useSolutionListing = (slug: string) => {
  return useQuery({
    queryKey: [SOLUTION_LISTING_QUERY_KEY, slug],
    queryFn: () => getSolutionListing(slug),
    enabled: Boolean(slug),
    staleTime: TEN_MINUTES,
    onError: toastErrorHandler,
  });
};
